export default "/public/app-main/static/image/efdfa55c55818a139dcff977b4939981.jpg";